/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>进门记录</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-date-picker
          v-model="date"
          type="date"
          placeholder="选择日期时间"
          default-time="12:00:00"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >搜索</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-upload2"
          @click="exportEnterRecord"
          >导出</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="menberList"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column
        prop="avatarUrl"
        label="头像"
        width="150"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">
          <img
            :src="scope.row.avatarUrl"
            alt="头像"
            style="max-width: 100%; max-height: 80px"
          />
        </template>
      </el-table-column>
      <el-table-column prop="nickName" label="用户名" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="phone" label="手机号" show-overflow-tooltip>
      </el-table-column>

      <el-table-column prop="openTime" label="进门时间" show-overflow-tooltip>
      </el-table-column>

      <!-- <el-table-column align="center" label="操作" min-width="80">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
            >预览</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="deleteUser(scope.$index, scope.row)"
            >退款</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="50%"
      @click="closeDialog('editForm')"
    >
      <el-form label-width="120px" :model="editForm" ref="editForm">
        <el-row>
          <el-col :span="20">
            <el-form-item label="图片">
              <el-input
                size="small"
                v-model="editForm.orderNum"
                auto-complete="off"
                placeholder="订单号"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="名称">
              <el-input
                size="small"
                v-model="editForm.payMethod"
                auto-complete="off"
                placeholder=""
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="成本">
              <el-input
                size="small"
                v-model="editForm.subtract"
                auto-complete="off"
                placeholder="请输入微信子商户"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="售价">
              <el-input
                size="small"
                v-model="editForm.price"
                auto-complete="off"
                placeholder="请输入通知回调"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="会员价">
              <el-input
                size="small"
                v-model="editForm.vipYouHuiPrice"
                auto-complete="off"
                placeholder="请输入加密类型"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="库存">
              <el-input
                size="small"
                v-model="editForm.activityYouHuiPrice"
                auto-complete="off"
                placeholder="请输入商户签名密钥"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="条码">
              <el-input
                size="small"
                v-model="editForm.activityYouHuiPrice"
                auto-complete="off"
                placeholder="请输入商户签名密钥"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="购买商品">
          <el-input
            size="small"
            v-model="editForm.newContent"
            auto-complete="off"
            placeholder="购买的商品"
            disabled
            style="white-space: pre-line"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { OrderList, OrderRefund, OrderDelete } from "../../api/payMG";
import Pagination from "../../components/Pagination";

import { blobValidate } from "@/utils/ruoyi";
import { saveAs } from "file-saver";

import {
  getGoodsList,
  getGoodsTypeList,
  getMemberList,
  getEnterRecord,
} from "@/api/api.js";
export default {
  data() {
    return {
      menberList: [], //列表
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "预览",
      date: "",
      year: "",
      month: "",
      day: "",
      goodsStatus: "", //商品类型
      payway: [
        { key: "全部订单", value: 0 },
        { key: "已完成订单", value: 1 },
        { key: "已取消订单", value: 2 },
        { key: "已退款订单", value: 3 },
      ],
      goodsTypeList: [], //商品类型列表
      orderList: "", //订单列表
      phone: "", //会员手机号
      goodsList: [], //商品列表
      editForm: {
        id: "",
        name: "",
        payType: 1,
        partner: "",
        subMchId: "",
        appid: "",
        notifyUrl: "",
        signType: "",
        partnerKey: "",
        sellerUserId: "",
        certPath: "",
        certPassword: "",
        rsaKey: "",
        token: localStorage.getItem("logintoken"),
      },
      formInline: {
        page: 1,
        limit: 10,
        machineNo: "",
        orderNo: "",
        transId: "",
        payType: 0,
        orderStatus: 0,
        token: localStorage.getItem("logintoken"),
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    // this.getdata(this.formInline);
    // this.getGoodsType();//获取商品类型列表
    this.date = new Date();
    this.getData(); //获取商品列表
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //获取商品类型列表
    getGoodsType() {
      getGoodsTypeList().then((res) => {
        //改变数组里元素的某个属性
        res.data.forEach((item) => {
          item.key = item.name;
          item.value = item.id;
        });
        //在数组开头添加一个元素
        res.data.unshift({ key: "所有", value: "" });
        this.goodsTypeList = res.data;
      });
    },
    //获取进门记录列表
    getData() {
      this.loading = true;
      const selectedDate = new Date(this.date);
      const formattedDate =
        selectedDate.getFullYear() +
        "-" +
        ("0" + (selectedDate.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + selectedDate.getDate()).slice(-2);
      getEnterRecord({
        date: formattedDate,
        phone: this.phone,
        pageNum: this.pageparm.currentPage,
        storeId: localStorage.getItem("storeId"),
      }).then((res) => {
        //改变数组里元素的某个属性
        // res.data.records.forEach((item)=>{
        //   item.payMethod = item.payMethod == 0 ? '微信' : '支付宝'
        //   item.orderStatus = item.orderStatus == 1 ? '已完成' : '生成中'
        //   item.newContent = item.content.replace(/\\n/g, '<br>')
        // })
        this.menberList = res.data.records;
        this.loading = false;

        // this.pageparm.pageSize = this.formInline.limit;
        this.pageparm.total = res.data.total;
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.pageparm.currentPage = parm.currentPage;
      this.formInline.limit = 10;
      console.log(parm.currentPage, "111111");
      // this.getdata(this.formInline)
      this.getData();
    },
    // 搜索事件
    search() {
      // this.getdata(this.formInline)
      this.pageparm.currentPage = 1;
      this.getData();
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      this.editForm = row;
      console.log(index, row, "333333");
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          ConfigSave(this.editForm)
            .then((res) => {
              this.editFormVisible = false;
              this.loading = false;
              if (res.success) {
                this.getdata(this.formInline);
                this.$message({
                  type: "success",
                  message: "公司保存成功！",
                });
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.loading = false;
              this.$message.error("支付配置信息保存失败，请稍后再试！");
            });
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          ConfigDelete(row.deptId)
            .then((res) => {
              if (res.success) {
                this.$message({
                  type: "success",
                  message: "公司已删除!",
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("支付配置信息删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false;
      this.$refs[formName].resetFields();
    },

    //导出进门记录
    exportEnterRecord() {
      let time = new Date(this.date);
      this.date =
        time.getFullYear() +
        "-" +
        ("0" + (time.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + time.getDate()).slice(-2);
      this.$confirm("确定导出开门记录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .get(
              this.$api.Domain+`/store/uploadStoreEnterRecord?storeId=${localStorage.getItem("storeId")}&date=${this.date}`,
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                  "token": localStorage.getItem("token"),
                  "storeId": localStorage.getItem("storeId"),

                },
                responseType: "blob",
              }
            )
            .then(async (res) => {
              const isLogin = await blobValidate(res);
              if (res.status == 200) {
                if (isLogin) {
                  console.log(new Blob([res]));
                  const blob = new Blob([res.data]);
                  console.log("blob1111", blob);
                  saveAs(blob, `销量列表_${new Date().getTime()}.xlsx`);
                  this.$message({
                    type: "success",
                    message: "导出成功",
                  });
                } else {
                  const resText = await res.text();
                  const rspObj = JSON.parse(resText);
                  const errMsg =
                    errorCode[rspObj.code] ||
                    rspObj.msg ||
                    errorCode["default"];
                  this.$message.error(errMsg);
                }
                this.$modal.closeLoading();
              } else {
                this.$message.error("导出失败");
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消导出",
          });
        });
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>







// WEBPACK FOOTER //
// src/views/machine/enterRecord.vue